var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParameters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 300.983,
    y1: 364.45,
    x2: 329.534,
    y2: 393.001,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    id: "fill0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 312.415,
    y1: 375.433,
    x2: 318.072,
    y2: 381.09,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    id: "fill1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73B4C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    stopColor: "#6AAEC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    stopColor: "#529EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#2C839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147391"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-292 -353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.478 395.234 307.243 391.262 323.243 391.262 327.008 395.234C331.963 391.594 335.243 385.168 335.243 378.549 335.243 367.504 326.289 358.262 315.243 358.262 304.197 358.262 295.243 367.647 295.243 378.693 295.243 385.312 298.524 391.594 303.478 395.234Z",
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#fill0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.243 375.262 306.243 369.262",
    stroke: "#147391",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.243 378.262C319.243 380.471 317.452 382.262 315.243 382.262 313.034 382.262 311.243 380.471 311.243 378.262 311.243 376.053 313.034 374.262 315.243 374.262 317.452 374.262 319.243 376.053 319.243 378.262Z",
    stroke: "#147391",
    strokeMiterlimit: 10,
    fill: "url(#fill1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameters);
export default __webpack_public_path__ + "static/media/Parameters.92f6dd10a7dff85741a6958c7431e8eb.svg";
export { ForwardRef as ReactComponent };